import React from 'react'
import { Outlet } from 'react-router-dom'
import { COMPANY_NAME, VERSION } from '@common'

export default function NonAuthLayout({ children }) {
    return (
        <div className="dashboard-bg p-0 m-0">
            <div className="dashboard-page-content pt-4">
                <div className="d-flex flex-grow-1 flex-column">
                    <Outlet />
                </div>

                <div className="mt-auto">
                    <div className="text-center text-muted p-4">
                        <p className="mb-0">
                            &copy; {new Date().getFullYear()}，{COMPANY_NAME}
                        </p>
                        <p className="text-muted opacity-50 mb-0 mt-1 no-print">v{VERSION}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
